module.exports = __webpack_public_path__ + "assets/img/dh2.819bb81a.jpg";